import { InjectionToken } from '@angular/core';

import { ASSETS_DIR } from '../common/tokens';

export type SoundsList<T> = Record<string, T>;

export type SoundsConfig<T> = {
  soundsDir: string;
  soundsList: SoundsList<T>;
};

export const SOUNDS_CONFIG = new InjectionToken<SoundsConfig<any>>('SOUNDS_CONFIG');

export function provideSounds(soundsList: Record<string, readonly string[]>) {
  return {
    provide: SOUNDS_CONFIG,
    useFactory: (assetsDir: string) => {
      return {
        soundsDir: `${ assetsDir }/sounds`,
        soundsList
      };
    },
    deps: [ ASSETS_DIR ]
  };
}